// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-registration-form--editable .birth-date--activator .v-text-field__slot>input{background-color:var(--v-secondary-lighten1)!important}.profile-registration-form--editable .birth-date--activator.v-text-field>.v-input__control>.v-input__slot:before{border-color:var(--v-primary-base)!important}", ""]);
// Exports
module.exports = exports;
